module.exports = __webpack_public_path__ + "img/genai1.d1d42703.png";